import { getFeatureFlags } from '@/flags'
import type { ViewProps } from "@/components/Viewer"
import { useLocation } from 'react-router-dom'
import { useHostedViewerCtx } from "@/hooks/use-app-ctx"

export type ConfigurationMode = "view" | "debug" | "edit"

export function useConfigMode() {
  const location = useLocation()
  return getConfigMode(location.pathname)
}

export function useConfigModeUrl(mode: ConfigurationMode): string {
  return getConfigModeUrl(mode, useHostedViewerCtx().viewProps)
}

export function getConfigModeUrl(
  mode: ConfigurationMode,
  viewProps: ViewProps
): string {
  const suffix = `${mode === "view" ? "" : mode}${window.location.search}`
  if (getFeatureFlags().values.localMode) return `/${suffix}`

  const { projectPath, viewerPath } = viewProps
  if (!projectPath || !viewerPath) throw new Error("Project and/or viewer path not found")
  return `/projects/${projectPath}/${viewerPath}/${suffix}`
}

export function getConfigMode(pathname = window.location.pathname): ConfigurationMode {
  if (pathname.endsWith('/edit')) return "edit"
  // Debug mode only exists in the experimental configurator
  if (pathname.endsWith('/debug') && getFeatureFlags().values.experimentalConfiguratorUx) return "debug"
  return "view"
}
